export const templateTypes = { // eslint-disable-line
    SILVER: 'silver',
    BUNDLE: 'bundle',
    REGULAR: 'regular',
    MADETOMEASURE: 'mtm',
    VDATA: 'vdata',
    BEAUTY: 'beauty',
};
